import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { useSnackbar } from "notistack";
import createAuthInterceptor from '../../utils/authInterceptor';

const { REACT_APP_API_ENDPOINT } = process.env;

const ManageCloseCampaignAffissioni = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const axiosInstance = createAuthInterceptor(navigate);

  const selectedCampaign = useMemo(
    () => campaigns.find(c => String(c._id) === String(selectedId)),
    [campaigns, selectedId]
  );

  const fetchCampaigns = async () => {
    try {
      const res = await axiosInstance.get(`${REACT_APP_API_ENDPOINT}/api/campaigns-affissioni`);
      setCampaigns(res.data || []);
    } catch (err) {
      enqueueSnackbar("Errore nel caricamento delle campagne", { variant: "error" });
    }
  };

  useEffect(() => {
    fetchCampaigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpenConfirm = () => {
    if (!selectedId) return;
    setConfirmOpen(true);
  };

  const handleCloseConfirm = () => setConfirmOpen(false);

  const handleConfirmClose = async () => {
    if (!selectedId) return;
    setLoading(true);
    try {
      await axiosInstance.post(`${REACT_APP_API_ENDPOINT}/api/affissioni/${selectedId}/chiudi`);
      enqueueSnackbar("Campagna chiusa con successo", { variant: "success" });
      setConfirmOpen(false);
      setSelectedId("");
      await fetchCampaigns(); // la campagna chiusa sparisce dalla select
    } catch (err) {
      enqueueSnackbar("Errore durante la chiusura", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" mt={4}>
      <Paper elevation={3} sx={{ p: 4, width: 400 }}>
        <Typography variant="h6" gutterBottom>
          Chiudi Campagna Affissioni
        </Typography>

        <FormControl fullWidth margin="normal">
          <InputLabel>Seleziona Campagna</InputLabel>
          <Select
            value={selectedId}
            label="Seleziona Campagna"
            onChange={(e) => setSelectedId(e.target.value)}
          >
            {campaigns.map((camp) => (
              <MenuItem key={camp._id} value={camp._id}>
                {camp.denominazione}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          variant="contained"
          color="warning"
          onClick={handleOpenConfirm}
          fullWidth
          disabled={!selectedId || loading}
          sx={{ mt: 2 }}
        >
          Chiudi Campagna
        </Button>
      </Paper>

      {/* Dialog conferma */}
      <Dialog open={confirmOpen} onClose={loading ? undefined : handleCloseConfirm}>
        <DialogTitle>Conferma chiusura</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mt: 1 }}>
            Sei sicuro di voler chiudere la campagna
            {selectedCampaign ? <> <strong>“{selectedCampaign.denominazione}”</strong>?</> : " selezionata?"}
            <br />
            Non apparirà più tra le campagne attive; potrai consultarla dagli snapshot.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm} disabled={loading}>Annulla</Button>
          <Button
            onClick={handleConfirmClose}
            color="warning"
            variant="contained"
            disabled={loading}
          >
            {loading ? "Chiusura..." : "Conferma chiusura"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ManageCloseCampaignAffissioni;
